export default "__VITE_ASSET__MBxtqziR__"